export type AdminTabId = 'dashboard' | 'klienti' | 'projekty' | 'faktury' | 'spravy' | 'ulohy';

export const adminTabMeta: Record<AdminTabId, { title: string; sub: string }> = {
  dashboard:  { title: 'Admin prehľad',       sub: 'Celkový stav agentúry v reálnom čase'        },
  klienti:    { title: 'Správa klientov',      sub: '12 aktívnych klientov'                        },
  projekty:   { title: 'Všetky projekty',      sub: '8 projektov prebieha'                         },
  faktury:    { title: 'Faktúry & platby',     sub: '3 faktúry čakajú na úhradu'                   },
  spravy:     { title: 'Správy klientov',      sub: '4 neprečítané správy'                         },
  ulohy:      { title: 'Všetky úlohy',         sub: '14 otvorených úloh naprieč projektmi'         },
};

export interface Client {
  id: string;
  initials: string;
  name: string;
  company: string;
  email: string;
  phone: string;
  status: 'active' | 'paused' | 'inactive';
  plan: string;
  mrr: number;
  projectCount: number;
  since: string;
  color: string;
}

export interface Project {
  id: string;
  name: string;
  client: string;
  clientInitials: string;
  clientColor: string;
  status: 'running' | 'review' | 'done' | 'paused';
  phase: string;
  progress: number;
  deadline: string;
  team: string[];
}

export interface Invoice {
  id: string;
  number: string;
  client: string;
  clientInitials: string;
  clientColor: string;
  amount: number;
  status: 'paid' | 'pending' | 'overdue';
  issued: string;
  due: string;
  service: string;
}

export interface AdminTask {
  id: string;
  title: string;
  client: string;
  project: string;
  priority: 'high' | 'medium' | 'low';
  status: 'open' | 'in_progress' | 'done';
  assignee: string;
  due: string;
}
